import {CreateEditTaskApiDto, TaskApiDto} from "../../api/model/rest";

export default class Task {
	constructor(public readonly id: string,
		public readonly title: string,
		public readonly installerDescription: string,
		public readonly customerDescription: string) {}

	static fromJson(json: TaskApiDto) {
		return new Task(json.id, json.title ? json.title : json.installerDescription.substr(0, 20), json.installerDescription, json.customerDescription);
	}

	toJson(): CreateEditTaskApiDto {
		return {
			title: this.title,
			installerDescription: this.installerDescription,
			customerDescription: this.customerDescription
		}
	}
}